import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../../api/axiosinstance";

function ProposalView() {
  const { id } = useParams();
  const [html, setHtml] = useState("");

  /* ================= FETCH PROPOSAL ================= */
  useEffect(() => {
    if (!id) return;
    fetchProposal();
  }, [id]);

  const fetchProposal = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SOCKET_URL}api/v1/proposals/public/${id}`
      );

      const data = await res.text(); // 👈 IMPORTANT
      setHtml(data);

    } catch (err) {
      console.log("Error loading proposal");
    }
  };

  useEffect(() => {
  if (!id) return;

  axios.post("/proposals/track-open", {
    proposalId: id,
  });
}, [id]);

  /* ================= TRACK OPEN ================= */
  // useEffect(() => {
  //   if (!id) return;

  //   trackOpen();
  // }, [id]);

  // const trackOpen = async () => {
  //   try {
  //     await axios.post("/proposals/track-open", {
  //       proposalId: id,
  //     });
  //   } catch (err) {
  //     console.log("Tracking failed");
  //   }
  // };

  /* ================= UI ================= */
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default ProposalView;